import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const crudder = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;

    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        get options() {
            return { headers: getHeaders(), url };
        },
        accountInformation: () => executeCall(() => Axios.get(url + '/account-information', { headers: getHeaders() })),
        accountLink: () => executeCall(() => Axios.get(url + '/account-link', { headers: getHeaders() })),
    };
};


export default crudder;